import Ayudas from './ayudas.vue';
import AyudaForm from './ayuda-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/ayudas/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('ayudas', ['ADMIN', 'DTYCAL'], Ayudas),
        keepAlive: true
    },
    {
        path: '/ayudas/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('ayudas/new', ['ADMIN', 'DTYCAL'], AyudaForm)
    },
    {
        path: '/ayudas/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('ayudas/edit', ['ADMIN', 'DTYCAL'], AyudaForm)
    },
    {
        path: '/ayudas/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('ayudas/view', ['ADMIN', 'DTYCAL'], AyudaForm, { editable: false })
    },
];
export default routes;
